import { ReactElement } from 'react';

import { Modal, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { consentTemplateActionTranslationKeys } from '../../../../translations';

import { ConsentTemplateActionForm } from './ConsentTemplateActionForm';

const t = consentTemplateActionTranslationKeys.modal;

type ConsentTemplateModalProps = {
   readonly onClose: VoidFunction;
   readonly patientId: number;
   readonly visitId: number;
   readonly priorityTemplateIds: number[];
};

export const ConsentTemplateModal = (props: ConsentTemplateModalProps): ReactElement => {
   return (
      <Modal title={t.title} width={ModalWidth.WIDE} testId={'consentsAndAuthorizationsDocuments'}>
         <ConsentTemplateActionForm
            onApproveAndPrint={props.onClose}
            patientId={props.patientId}
            visitId={props.visitId}
            priorityTemplateIds={props.priorityTemplateIds}
         />

         <ModalConfirmButton label={t.actions.close} onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
